import { Box, Tooltip, TextField, InputAdornment } from "@mui/material";
import { ValidationRule, useFormContext } from "react-hook-form";
import { Error } from "@mui/icons-material";
import React from "react";
import { useTranslation } from "@refinedev/core";

type ValidatedTextfieldProps = {
  name: string;
  startAdornment?: React.ReactNode;
  max?: ValidationRule<number | string>;
  required?: boolean;
};

export const ValidatedTextfield = (props: ValidatedTextfieldProps) => {
  const { name, startAdornment, max, required = true } = props;
  const { translate } = useTranslation();

  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Box position="relative" display="inline-flex" alignItems="center">
      {errors[name] && (
        <Tooltip
          title={errors[name]?.message?.toString() ?? ""}
          placement="top"
        >
          <Error
            color="error"
            sx={{ position: "absolute", right: -8, top: -4, zIndex: 1000 }}
          />
        </Tooltip>
      )}
      <TextField
        margin="none"
        size="small"
        type="number"
        sx={{ width: "100px" }}
        error={!!errors[name]}
        {...register(name, {
          valueAsNumber: true,
          max: max,
          min: {
            value: 1,
            message: translate("common.errors.min", {
              min: 1,
            }),
          },
          required: required ? translate("common.errors.required") : undefined,
        })}
        slotProps={
          startAdornment
            ? {
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      {startAdornment}
                    </InputAdornment>
                  ),
                },
              }
            : {}
        }
      />
    </Box>
  );
};
